// Cliente no alto e no CENTRO das duas últimas telas do BALCÃO ("Como deseja
// consumir?" e "Forma de Pagamento") — pedido do dono, 29/09/2026. Sem
// cliente: a busca do cadastro (BuscaClienteBalcao; só vale cliente
// cadastrado). Com cliente: o chip dele e o X para trocar. O pai precisa ser
// `relative` (ou absoluto): o bloco se centraliza nele.
import { X } from "lucide-react";

import BuscaClienteBalcao from "./BuscaClienteBalcao";

export default function NomeCliente({ ctx, className = "" }) {
  const { cliente, setCliente, setCustomerName, chipCliente } = ctx;
  const escolher = (c) => { setCliente(c); setCustomerName(c?.nome || ""); };
  return (
    <div className={`absolute left-1/2 -translate-x-1/2 z-30 ${className}`} data-e2e="nome-cliente-centro">
      {cliente ? (
        <div className="flex items-center gap-2">
          {chipCliente()}
          <button type="button" onClick={() => escolher(null)} title="Trocar o cliente" data-e2e="trocar-cliente"
            className="w-8 h-8 rounded-full bg-zinc-800 hover:bg-zinc-700 flex items-center justify-center text-zinc-400"><X className="w-4 h-4" /></button>
        </div>
      ) : <BuscaClienteBalcao onEscolher={escolher} />}
    </div>
  );
}
